import { css } from 'styled-system/css'

// Matches the Setups prototype's .pill / .pill.on / .pill:hover exactly.
export const pill = (active: boolean) => css({
  border: '1.5px solid',
  borderColor: active ? 'editorialAccent' : 'transparent',
  bg: active ? 'gray.surface.bg' : 'transparent',
  color: active ? 'editorialInk' : 'editorialInk3',
  fontWeight: '600',
  fontSize: '12px',
  textTransform: 'capitalize',
  px: '12px',
  py: '5px',
  borderRadius: '999px',
  cursor: 'pointer',
  transition: 'background 0.15s, color 0.15s, border-color 0.15s',
  // The prototype's .pill.on wins the cascade over .pill:hover (equal
  // specificity, .on declared later), so hovering a selected pill doesn't
  // change it — only unselected pills get the hover treatment.
  ...(active ? {} : {
    _hover: {
      bg: 'editorialHover',
      color: 'editorialInk',
    },
  }),
})
